import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { KPIWidgetComponentItem, KPIWidgetDisplayItems } from '../extended-kpi/extended-kpi.model';
import { ExtendedKpiService } from '../extended-kpi/extended-kpi.service';
import {  ChartConfiguration } from 'chart.js';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
    selector: 'cv-extended-kpi-item',
    templateUrl: './extended-kpi-item.component.html',
    styleUrls: ['./extended-kpi-item.component.scss']
})
export class ExtendedKpiItemComponent implements OnInit {
    @Input() itemId: string;
    @Input() data: KPIWidgetComponentItem;
    @Input() displayItems: KPIWidgetDisplayItems;

    @ViewChild('canvasContainer', { static: false }) canvasContainer: ElementRef;
    @ViewChild('trend', { static: false }) trend: ElementRef;

    public chartExpanded = false;
    public chartConfig = null;
    private chartTimer: number = null;
    private chartLoaded = false;
    private localizedString: string = "";

    private chartExpanding = false;

    constructor(
        private extendedKpiService: ExtendedKpiService,
        private config: CvConfigurationService,
        private cvLocalizationService: CVLocalizationService
    ) { }

    ngOnInit(): void {
        if (this.data.GraphData) this.initChart();
        this.cvLocalizationService.GetSection("Common").then(() => this.localizedString = this.cvLocalizationService.getCachedText("Common", "Original_Metric"));
    }

    initChart = () => {
        if (this.chartTimer) {
            clearTimeout(this.chartTimer);
            this.chartTimer = null;
        }

        this.chartTimer = window.setTimeout(() => {
            this.chartConfig =  {
                type: "bar",
                data: {
                    labels: this.data.GraphData.DisplayData,
                    datasets: [{
                        backgroundColor: this.data.BarData.color,
                        data: this.data.GraphData.Data,
                    }]
                },
                options: {
                    maintainAspectRatio: false,
                    layout: {
                        padding: 0,
                    },
                    plugins: {
                        emptyChart: {
                            disableCxone: this.config.isCxOne,
                        },
                        legend: {
                            display: false
                        },
                        tooltip: {
                            enabled: false,
                        },
                    },
                    scales: {
                        x: {
                            display: false,
                            grid: {
                                display: false
                            },
                            ticks: {
                                display: false
                            },
                        },
                        y: {
                            display: false,
                            grid: {
                                display: false
                            },
                            suggestedMin: this.data.GraphData.Min,
                            suggestedMax: this.data.GraphData.Max,
                            ticks: {
                                display: false,
                            },
                        }
                    },
                },
                plugins: [{
                    id: 'eventCatcher',
                    beforeEvent: (chart, args, pluginOptions) => {
                        const event = args.event;
                        if (event.type === 'mouseout') {
                            const tooltipEl = document.getElementById('chartjs-tooltip');
                            if (tooltipEl)
                                tooltipEl.style.opacity = '0';
                        }
                    }
                }]
            } as ChartConfiguration;

            this.chartLoaded = true;
        }, 2000);
    };

    public mouseover(trend: HTMLElement): void {
        if (this.data.BarData.segments.length < 2) return;

        $(trend).animate({ opacity: 0 }, { duration: 200, queue: false });
    }

    public mouseleave(trend: HTMLElement): void {
        if (this.data.BarData.segments.length < 2) return;

        $(trend).animate({ opacity: 1 }, { duration: 200, queue: false });
    }

    public getCanvasSize(canvasContainer: HTMLElement): object {
        if (this.chartExpanding) return;

        if (this.chartExpanded)
            return {
                height: canvasContainer.offsetHeight + "px",
                width: canvasContainer.offsetWidth + "px"
            };

        const value = document.getElementById(`${this.itemId}_value`);
        if (!value) return;

        return {
            height: value.offsetHeight + "px",
            width: value.offsetHeight * 2 + "px"
        };
    }

    public expandChart(canvasContainer: HTMLElement): void {
        if (this.chartExpanded || this.chartExpanding) return;

        this.chartExpanding = true;

        $(`#${this.itemId}_valueWrapper`).css('position', 'static'); // IE Fix

        const cc = $(canvasContainer);
        cc.animate({
            height: '100%',
            width: '100%'
        }, 200);

        window.setTimeout(() => {
            this.chartExpanded = true;
            this.chartExpanding = false;
        }, 200);

        this.chartConfig.data.datasets[0].backgroundColor = this.data.GraphData.BackgroundColor.map(bc => bc ?? '#e5e5e5');

        this.chartConfig.options.plugins.tooltip.enabled = false;
        this.chartConfig.options.plugins.tooltip.external = this.displayTooltip.bind(this);
        this.chartConfig.options.layout.padding = {
            top: 10,
            right: 10,
            left: 10,
            bottom: 0
        };
    }

    public shrinkChart(canvasContainer: HTMLElement): void {
        if (!this.chartExpanded) return;

        const value = document.getElementById(`${this.itemId}_value`);
        if (!value) return;

        $(`#${this.itemId}_valueWrapper`).css('position', 'relative'); // IE Fix
        // document.getElementById(`${this.itemId}_valueWrapper`)

        const cc = $(canvasContainer);
        cc.animate({
            top: 'initial',
            height: value.offsetHeight,
            width: value.offsetHeight * 2
        }, 200);

        this.chartConfig.data.datasets[0].backgroundColor = this.data.BarData.color;
        this.chartConfig.options.plugins.tooltip.enabled = false;
        this.chartConfig.options.plugins.tooltip.external = null;
        this.chartConfig.options.layout.padding = 0;
        this.chartExpanded = false;
    }

    public displayTooltip(event): void {
        if (!this.chartExpanded) {
            return;
        }
        let tooltipEl = document.getElementById('chartjs-tooltip');

        // Remove existing tooltip
        if (tooltipEl) {
            tooltipEl.remove();
        }

        tooltipEl = document.createElement('div');
        tooltipEl.id = 'chartjs-tooltip';
        document.body.appendChild(tooltipEl);

        // Set caret Position
        tooltipEl.classList.remove('above', 'below', 'no-transform');
        if (event.active[0])
            tooltipEl.classList.add('center');
        else
            tooltipEl.classList.add('no-transform');

        // Set style
        tooltipEl.classList.add('position-absolute', 'rounded', 'text-white', 'px-2');
        tooltipEl.style.backgroundColor = 'rgba(53,58,64,.8)';
        tooltipEl.style.zIndex = '100000';

        //#region Set Content
        if (event.active[0]) {
            const index = event.active[0].index;

            if (this.data.GraphData.DisplayData[index] === 'N/A')
                return;

            // Horizontal Ruler
            const hrEl = document.createElement('hr');
            hrEl.className = 'border-light';

            // Set title
            const titleEl = document.createElement('div');
            titleEl.className = 'm-1';
            titleEl.innerHTML = this.data.ComponentHeading;
            tooltipEl.appendChild(titleEl);

            tooltipEl.innerHTML += '<hr class="border-light" />';

            // Set Objective Info
            if (this.data.GraphData.Objective) {
                const objectiveEl = document.createElement('div');
                objectiveEl.className = 'd-flex justify-content-between m-1';
                // objectiveEl.style.color = this.data.graphData.backgroundColor[index];
                const color = `<div style="height: 14px; width: 14px; margin-right: 4px; border: 1px solid #ffffff; background-color:
                     ${this.data.GraphData.BackgroundColor[index]};"></div>`;
                objectiveEl.innerHTML += `<div class="d-flex align-items-center">${color} Obj<div>`;
                objectiveEl.innerHTML += `<div class="mx-2">&rsaquo;&rsaquo;</div>`;
                objectiveEl.innerHTML += `<div>${this.data.GraphData.Objective[index]}</div>`;
                tooltipEl.appendChild(objectiveEl);

                tooltipEl.innerHTML += '<hr class="border-light" />';
            }

            // Set Value
            const valueEl = document.createElement('div');
            valueEl.className = 'd-flex justify-content-between m-1';
            valueEl.innerHTML += `<div>${this.data.GraphData.Start[index]}<div>`;
            valueEl.innerHTML += `<div class="mx-2">&rsaquo;&rsaquo;</div>`;
            valueEl.innerHTML += `<div>${this.data.GraphData.DisplayData[index]}</div>`;
            tooltipEl.appendChild(valueEl);
        }
        //#endregion

        const position = event.event.chart.canvas.getBoundingClientRect();
        tooltipEl.style.opacity = '1';
        // left position of chart + number of bars over + number of spaces between bars over - half width of tooltip
        tooltipEl.style.left = position.left + (event.active[0]?.element.width * event.active[0]?.index)
            + (event.active[0]?.index * 13) - (tooltipEl.offsetWidth / 2) + 'px';
        tooltipEl.style.top = position.top + event.active[0]?.element.y - tooltipEl.offsetHeight - 5 + 'px';
    }

    getMetricDisplayName(data){
        if(data.MetricCustomName && data.MetricCustomName !== '')
            return data.MetricCustomName + "*";
        
        return data.ComponentHeading
    }

    getMetricToolTip(data)
    {
        return data.MetricCustomName && data.MetricCustomName !== '' ? 
        this.localizedString +": " + "\n" + data.ComponentHeading : null;
    }

    private getOffsetPosition(start: any, element: HTMLElement): any {
        const offsetPosition = start;

        do {
            if (!isNaN(element.offsetLeft))
                offsetPosition.left += element.offsetLeft;

            if (!isNaN(element.offsetTop))
                offsetPosition.top += element.offsetTop;
        } while (element === element.offsetParent as HTMLElement);

        return offsetPosition;
    }
}
